var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9992 8.04627C23.9172 8.11715 23.7859 8.25981 23.6373 8.52223L6.22476 39.2729C6.04895 39.5834 6.00787 39.787 6.00118 39.878C6.00115 39.8784 6.00113 39.8788 6.0011 39.8792C6.08588 39.9257 6.28839 40 6.70583 40H41.2947C41.7125 40 41.9147 39.9251 41.999 39.8786C41.9989 39.8782 41.9989 39.8778 41.9989 39.8775C41.9923 39.7871 41.9516 39.5838 41.7756 39.273L24.3613 8.5223C24.2127 8.25987 24.0813 8.11716 23.9992 8.04627ZM42.05 39.8424C42.0503 39.8425 42.048 39.8452 42.0427 39.8497C42.0472 39.8444 42.0498 39.8422 42.05 39.8424ZM5.9493 39.8426C5.94951 39.8423 5.95227 39.8447 5.95699 39.8502C5.95144 39.8455 5.94909 39.8428 5.9493 39.8426ZM24.0007 4C25.7465 4.00079 27.0603 5.17104 27.8419 6.5512L45.2562 37.3019C46.0534 38.7096 46.3471 40.4431 45.4493 41.9409C44.5598 43.4249 42.9041 44 41.2947 44H6.70583C5.09374 44 3.43675 43.4243 2.54818 41.9378C1.65249 40.4393 1.94861 38.7067 2.74405 37.302L20.1566 6.55128C20.9392 5.16929 22.2541 3.99921 24.0007 4Z",
    fill: "#DE3121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 37C25.1046 37 26 36.1046 26 35C26 33.8954 25.1046 33 24 33C22.8954 33 22 33.8954 22 35C22 36.1046 22.8954 37 24 37Z",
    fill: "#DE3121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 17C25.1046 17 26 17.8954 26 19V29C26 30.1046 25.1046 31 24 31C22.8954 31 22 30.1046 22 29V19C22 17.8954 22.8954 17 24 17Z",
    fill: "#DE3121"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.559108a1.svg";
export { ForwardRef as ReactComponent };